import React, { useEffect, useMemo } from "react";
import {
  CheckCircleIcon,
  XCircleIcon,
  XMarkIcon,
} from "@heroicons/react/24/outline";
import { useTranslation } from "react-i18next";
import useLanguageDirection from "../../hooks/useLanguageDirection";
// import main from "./assets/images/boxOne.webp";
import main from "./../../assets/images/boxOne.webp";

const StatusModal = ({
  isOpen,
  onClose,
  status,
  title,
  message,
  autoCloseDuration = 2000,
}) => {
  const { t } = useTranslation();
  const direction = useLanguageDirection();

  const {
    icon: StatusIcon,
    titleKey,
    messageKey,
    subMessage,
    bgColor,
    btnColor,
  } = useMemo(() => {
    if (status === "success") {
      return {
        icon: CheckCircleIcon,
        titleKey: title,
        messageKey: message,
        subMessage: t("discountActivated"),
        bgColor: "bg-green-100",
        btnColor: "bg-green-500 hover:bg-green-600",
      };
    } else if (status === "error") {
      return {
        icon: XCircleIcon,
        titleKey: title,
        messageKey: message,
        subMessage: t("tryAgain"),
        bgColor: "bg-red-100",
        btnColor: "bg-red-500 hover:bg-red-600",
      };
    }
    return {
      icon: CheckCircleIcon,
      titleKey: "Success",
      messageKey: "Operation completed.",
      bgColor: "bg-gray-100",
      btnColor: "bg-gray-500 hover:bg-gray-600",
    };
  }, [status, title, message]);

  useEffect(() => {
    if (isOpen && status === "success" && autoCloseDuration > 0) {
      const timer = setTimeout(() => {
        onClose();
      }, autoCloseDuration);
      return () => clearTimeout(timer);
    }
  }, [isOpen, onClose, status, autoCloseDuration]);

  if (!isOpen) return null;

  return (
    <>
      <style>{`
        .bg-custom-yellow { background-color: #ffc107; }
        .hover\\:bg-black:hover { background-color: #000; }
        
        @keyframes fadeIn { from { opacity: 0; } to { opacity: 1; } }
        @keyframes pop { 0% { transform: scale(0.5); opacity: 0; } 80% { transform: scale(1.1); opacity: 1; } 100% { transform: scale(1); } }
        .animate-fadeIn { animation: fadeIn 0.3s ease-out; }
        .animate-pop { animation: pop 0.4s ease-out; }

        .progress-line { animation: grow ${
          autoCloseDuration / 1000
        }s linear forwards; }
        @keyframes grow { from { width: 0%; } to { width: 100%; } }
      `}</style>

      <div
        className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 animate-fadeIn"
        dir={direction}
      >
        <div className="relative z-10 w-full md:p-8 p-4 text-center border border-gray-100 shadow-2xl md:max-w-xl max-w-[90%] bg-yellow-50 animate-pop">
          <div
            className="absolute inset-0 z-0 w-full h-full transition-opacity duration-500"
            style={{
              backgroundImage: `url(${main})`,
              backgroundRepeat: "repeat",
              width: "auto",
              height: "auto",
              backgroundPosition: "center",
              opacity: 0.03,
            }}
          />
          <button
            onClick={onClose}
            className="absolute z-10 p-1 text-gray-400 transition-colors rounded-full top-4 left-4 hover:bg-gray-100"
          >
            <XMarkIcon className="w-5 h-5" />
          </button>

          <div className={`flex justify-center mb-6 relative z-10`}>
            <div className={`p-4 rounded-full ${bgColor}`}>
              <StatusIcon
                className={`w-16 h-16 ${
                  status === "success" ? "text-green-500" : "text-red-500"
                } animate-pop`}
              />
            </div>
          </div>

          <h2 className="relative z-10 mb-2 text-lg font-extrabold text-gray-800 lg:text-3xl">
            {titleKey}
          </h2>
          <p
            className={`mb-2 text-sm md:text-base text-gray-800 relative z-10`}
          >
            {messageKey}{" "}
          </p>
          <p className="relative z-10 mb-6 font-medium text-green-600">
            {subMessage}
          </p>

          {/* {status === "success" && ( */}
          {/* <div className="relative z-10 w-full h-1 mb-6 overflow-hidden bg-gray-200 rounded">
              <div
                className={`h-full ${
                  status === "success" ? "bg-green-500" : "bg-red-500"
                } progress-line`}
              ></div>
            </div> */}
          {/* )} */}

          <button
            onClick={onClose}
            className={` px-8 py-3 text-white font-bold  transition-all shadow-md ${btnColor} active:scale-95 relative z-10`}
          >
            {t("close")}
          </button>
        </div>
      </div>
    </>
  );
};

export default StatusModal;
